import React from 'react';
import classnames from 'classnames';

import P from '@deliveroo/consumer-component-library/components/P';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Span from '@deliveroo/consumer-component-library/components/Span';

import HomeIcon from '../HomeIcon';

import {
  UITextLineShape,
  UITitleLineShape,
  UITextLineProps,
  UITitleLineProps,
} from './shared/proptypes';

import styles from './styles.scss';

const spacerSizeMap = {
  X_SMALL: 'x-small',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  X_LARGE: 'x-large',
};

const iconSizeMap = {
  SMALL: 18,
  MEDIUM: 24,
};

const textSizeMap = {
  SMALL: 'small',
  MEDIUM: 'regular',
};

const getSpacerSize = (size) => spacerSizeMap[size] || 'small';
const getIconSize = (size) => iconSizeMap[size] || 18;
const getTextSize = (size) => textSizeMap[size] || 'small';
const getHexColor = (data) => (data.color && data.color.hex) || 'initial';

// Component to render Titles in the UICard
export const UITitleLine = ({ text, color, isPlaceholder, truncate }) => (
  <li
    className={classnames(styles.titleLine, styles.uiLineItem, {
      [styles.truncate]: truncate,
    })}
  >
    <span
      className={classnames({ [styles.placeholder]: isPlaceholder })}
      style={{
        color: `${color ? color.hex : 'initial'}`,
      }}
    >
      <P size="small" isBold>
        {text}
      </P>
    </span>
  </li>
);

UITitleLine.propTypes = UITitleLineShape;
UITitleLine.defaultProps = UITitleLineProps;

// Component to render metadata content in the UICard
export const UITextLine = ({ uiSpans, truncate, withPadding }) => (
  <li
    className={classnames(styles.uiLineItem, {
      [styles.truncate]: truncate,
      [styles.withPadding]: withPadding,
    })}
  >
    {uiSpans.map((data) => {
      const color = getHexColor(data);
      return (
        <span
          className={styles.uiSpan}
          style={{
            color,
          }}
          key={data.key}
        >
          {data.typeName === 'UISpanText' && (
            <Span size={getTextSize(data.textSize)} isBold={data.isBold}>
              {data.text}
            </Span>
          )}
          {data.typeName === 'UISpanIcon' && (
            <HomeIcon
              size={getIconSize(data.iconSize)}
              name={data.icon.name}
              fallbackImage={data.icon.image}
            />
          )}
          {data.typeName === 'UISpanSpacer' && (
            <Spacer spacing={`0 0 0 ${getSpacerSize(data.width)}`}>
              <span />
            </Spacer>
          )}
        </span>
      );
    })}
  </li>
);

UITextLine.propTypes = UITextLineShape;
UITextLine.defaultProps = UITextLineProps;
